import styles from './style.module.scss';
import Modal from '../../components/Modal'
import { examRules } from '../../config/exam';
import { useDispatch } from '../../store/store';
import { setExamRulesModal } from '../../store/exam/slice';

export default function ExamRules() {
    const dispatch = useDispatch();

    const close = () => dispatch(setExamRulesModal(false));

    return (
        <Modal
            size='lg'
            title='Exam Rules'
            closeFunc={close}
            actions='confirm'
            confirmButton={{
                text: 'Confirm',
                type: 'Primary',
                onClick: close,
            }}
        >
            <div className={styles.examRules}>
                {examRules.map((i, indx) => (<div className={styles.rule}>
                    <span className={styles.rule_title}>{indx + 1}. {i.title}</span>
                    <span className={styles.rule_description}>{i.description1}</span>
                    <span className={styles.rule_description}>{i.description2}</span>
                </div>))}
                <p>
                    We highly recommend opening a browser with one tab for
                    the exam and closing all other browser windows and tabs.
                </p>
            </div>
        </Modal>
    )
}
